// src/app/slices/eliminatorSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EliminatorState, IEliminator, IEliminatorParams } from '../models';

const initialState: EliminatorState = {
  eliminators: {},
  eliminator_params: null,
};

const eliminatorSlice = createSlice({
  name: 'eliminator',
  initialState,
  reducers: {
    setEliminator: (state, action: PayloadAction<IEliminator>) => {
      state.eliminators[action.payload.id] = action.payload;
    },
    setEliminatorParams: (state, action: PayloadAction<IEliminatorParams>) => {
      state.eliminator_params = action.payload;
    },
  },
});

export const { setEliminator, setEliminatorParams } = eliminatorSlice.actions;

export default eliminatorSlice.reducer;
